
<!-- #region Image Modal -->
<div class="modal fade" id="enLargeImageModal" tabindex="-1" aria-labelledby="enLargeImageModalLabel"
  aria-hidden="true">
  <div class="modal-dialog w-auto modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 *ngIf="!enLargeImage.includes('video/mp4') && !enLargeImage.includes('base64,AAAA')" class="modal-title fs-5" id="enLargeImageModalLabel">
          {{enLargeImgTitle}}
          <button class="btn downlaodImage py-1 ms-2" (click)="downloadImage()">Download Image</button>
        </h1>

        <!-- #region image tools -->
        <div class="d-flex">
          <button class="btn btn-secondary py-1 ms-2" data-bs-toggle="tooltip" data-bs-placement="top"
            title="Rotate 90°" (click)="rotateImage(90)"><i class="bi bi-arrow-clockwise"></i></button>
          <button class="btn btn-secondary py-1 ms-2" data-bs-toggle="tooltip" data-bs-placement="top"
            title="Rotate -90°" (click)="rotateImage(-90)"><i class="bi bi-arrow-counterclockwise"></i></button>
          <button class="btn btn-secondary py-1 ms-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Zoom In"
            (click)="zoomImage(1.1)"><i class="bi bi-zoom-in"></i></button>
          <button class="btn btn-secondary py-1 ms-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Zoom Out"
            (click)="zoomImage(0.9)"><i class="bi bi-zoom-out"></i></button>
          <button class="btn btn-secondary py-1 ms-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Reset"
            (click)="rotationDegree=0; zoomLevel=1;">Reset</button>
        </div>
        <!-- #endregion -->

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body w-auto enlargeImage-modal-body">
        <div clsas="enlargeImage-image-container">
            <img *ngIf="!enLargeImage.includes('video/mp4') && !enLargeImage.includes('base64,AAAA')"
           class="enlargeImage" 
           [src]="enLargeImage.startsWith('data:') ? enLargeImage : 'data:image/jpeg;base64,' + enLargeImage"
           [ngStyle]="{'transform': 'rotate(' + rotationDegree + 'deg) scale(' + zoomLevel + ')'}"
           style="max-width: 100%; max-height: 70vh; object-fit: contain;">

            <!-- Dynamic fallback: Display a VIDEO element if the source contains mp4 string tracks -->
            <video *ngIf="enLargeImage.includes('video/mp4') || enLargeImage.includes('base64,AAAA')"
                  controls 
                  autoplay
                  class="enlargeImage"
                  [src]="enLargeImage.startsWith('data:') ? enLargeImage : 'data:video/mp4;base64,' + enLargeImage"
                  [ngStyle]="{'transform': 'rotate(' + rotationDegree + 'deg) scale(' + zoomLevel + ')'}"
                  style="max-width: 100%; max-height: 70vh; object-fit: contain;">
            </video>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- #endregion -->
